import { Model } from "pinia-orm";
export default class QuestionnaireSession extends Model {
  static name = "QuestionnaireSession";
  static entity = "questionnaireSessions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      scenario: this.string(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),
      relatedObjectUuid: this.string(null),
      questions: this.attr([]),
      createdBy: this.string(""),
      modifiedBy: this.string(""),
      startDate: this.string(""),
      finishedDate: this.string(""),
      totalScore: this.number(0),
      totalNotation: this.number(0),
      isFinished: this.boolean(false),
      isCurrent: this.boolean(false),
    };
  }
}
